// Creator names, out of the one file that records them.
//
// The list of creators is derived from the catalog rather than written down
// (see useRankedCreators), so a handle is all any of these screens starts
// with. spotlights.json is where a real name gets attached to one, filled in
// by scripts/backfill-creators.mjs and eyeballed before it lands.
import spotlights from '../data/spotlights.json';

const TITLES = new Map((spotlights.creators as { handle: string; title: string }[]).map((c) => [c.handle, c.title]));

/** What to call a creator: the written-up name where there is one, else the
 *  handle. Every list of creators reads it through here, so a name added to
 *  spotlights.json shows up in all of them at once. */
export const creatorName = (handle: string) => TITLES.get(handle) ?? `@${handle}`;
